import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'dva';
import { useLocation, history } from 'umi';
import qs from 'qs';
import dayjs from 'dayjs';
import { Box } from '@material-ui/core';
import SearchGroup from './components/search_group/SearchGroup';
import ResultList from './components/result_list/ResultList';

export default () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { query, pathname } = location;
  const searchRef = useRef();
  const [isSearch, setIsSearch] = useState(false);
  // 结构到所有查询条件，包括分页条件
  const {
    appId,
    tab = '1',
    type,
    title,
    refreshTime,
    pageNum = '1',
    pageSize = '10',
  } = query;
  const { appIdList = [] } = useSelector((state) => state.templateList);
  const defaultAppid = appIdList?.[0]?.appId;
  const isWmpPage = pathname.includes('/miniapps/template_list');

  //tab切换事件处理
  const handleTabChange = (newParam) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };
  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        tab: '2',
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        tab: '2',
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };

  //模板列表
  const fetchWechatTemplateList = useCallback(() => {
    const values = {
      pageNum,
      pageSize,
      appId,
      refreshTime,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'templateList/getWechatTemplateList',
      payload: {
        values: {
          pageNum,
          pageSize,
          appId,
          refreshTime,
          isWmpPage,
        },
      },
    });
  }, [dispatch, pageNum, pageSize, appId, refreshTime, isWmpPage]);
  //模板消息列表
  const fetchWechatTemplateMessageList = useCallback(() => {
    const values = {
      pageNum,
      pageSize,
      appId,
      title,
      type,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'templateList/getWechatTemplateMessageList',
      payload: {
        values: {
          pageNum,
          pageSize,
          appId,
          title,
          type,
          isWmpPage,
        },
      },
    });
  }, [dispatch, pageNum, pageSize, appId, title, type, isWmpPage]);

  useEffect(() => {
    const isExist =
      appIdList.length > 0 ? appIdList?.some((i) => i.appId === appId) : false;
    if (defaultAppid && !isExist) {
      history.replace(
        `${pathname}?${qs.stringify({
          ...query,
          appId: defaultAppid,
        })}`,
      );
    }
  }, [appId, appIdList, defaultAppid, pathname, query]);

  useEffect(() => {
    if (tab === '1') {
      if (appId) {
        fetchWechatTemplateList();
      }
    } else if (tab === '2') {
      if (appId) {
        fetchWechatTemplateMessageList();
      }
    }
  }, [fetchWechatTemplateList, fetchWechatTemplateMessageList, tab, appId]);

  const getWechatTemplateList = () => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        refreshTime: time,
        tab: '1',
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  return (
    <Box
      data-log={JSON.stringify({
        oid: 'page_wechat_account_template_message_template_list',
        isPage: true,
        params: {
          initUrl: window.location.origin + window.location.pathname,
        },
        events: ['_pv', '_pd'],
      })}
    >
      <SearchGroup
        searchRef={searchRef}
        setIsSearch={setIsSearch}
        handleSearch={handleSearch}
        query={query}
        restClick={handleRestClick}
        getWechatTemplateList={getWechatTemplateList}
      />
      <ResultList
        handleTabChange={handleTabChange}
        tab={tab}
        pageData={{ pageSize, pageNum }}
        handlePageChange={handlePageChange}
      />
    </Box>
  );
};
